module.exports = __webpack_public_path__ + "media/images/edit-6949d4e4f883fe12434d479d3986d30f.png";